
import { computed } from '@nuxtjs/composition-api';
import useUtilities from '~/composable/useUtilities';

export default {
  props: {
    storageOptions: {
      type: Array,
      default: () => []
    },
    activeStorage: {
      type: String,
      default: null
    },
    priceIndexPerStorage: {
      type: Array,
      default: () => []
    }
  },
  setup(props) {
    const { formatPrice } = useUtilities()

    return {
      formatPrice,
      selectedStorage: computed(() => props.storageOptions.indexOf(props.activeStorage))
    }
  }
}
